import { unsafeCSS } from "lit";
import { customElement, property } from "lit/decorators.js";
import { html, unsafeStatic } from "lit/static-html.js";
import { EkoElement } from "@/utilities/element";
import { getSafeTag, type Tag } from "@/utilities/html";
import style from "./heading.css?inline";

@customElement("eko-heading")
class Heading extends EkoElement {
  static styles = [...EkoElement.styles, unsafeCSS(style)];

  @property() as?: Tag; // default is `h1`
  @property({ reflect: true }) size?: "sm" | "md" | "lg" | "xl" | "2xl"; // default is `md`
  @property({ reflect: true }) theme?:
    | "default"
    | "danger"
    | "info"
    | "warning"
    | "weak"
    | "weaker"
    | "weakest" = "default"; // default is `default`
  @property({ reflect: true }) weight?: "normal" | "medium" | "semibold" | "bold"; // default is `semibold`

  render() {
    return html`
      <${unsafeStatic(this.tag)} class="eko-heading" part="root">
        <slot></slot>
      </${unsafeStatic(this.tag)}>
    `;
  }

  private get tag() {
    return getSafeTag(this.as, "h1");
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "eko-heading": Heading;
  }
}

export default Heading;
